import { render, staticRenderFns } from "./MainStudySituation.vue?vue&type=template&id=51710951&scoped=true&"
import script from "./main-study-situation.js?vue&type=script&lang=js&"
export * from "./main-study-situation.js?vue&type=script&lang=js&"
import style0 from "./MainStudySituation.vue?vue&type=style&index=0&id=51710951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51710951",
  null
  
)

export default component.exports